import { render, staticRenderFns } from "./areaChargesProject.vue?vue&type=template&id=25cc6cda&"
import script from "./areaChargesProject.vue?vue&type=script&lang=js&"
export * from "./areaChargesProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports